import { useTableLinkVariant } from 'components/Tables/CommonTableCells/TableLinkStyleContext'

/**
 * Renders the expense category value. Inside the DS2026 surface
 * (TableLinkStyleProvider variant="plain") it appears as a white pill with
 * Gray/700 text; elsewhere it falls back to plain text matching the original
 * cell rendering.
 */
export function ExpenseCategoryBadge({ value }: { value: string | null }) {
  const variant = useTableLinkVariant()
  if (!value) return <>-</>

  if (variant === 'plain') {
    return (
      <span
        data-expense-badge
        className="inline-flex items-center rounded-2xl bg-neutral-100 px-2.5 py-0.5 text-sm font-medium leading-5 text-neutral-700"
        style={{ letterSpacing: '-0.2px' }}
      >
        {value}
      </span>
    )
  }

  return <>{value}</>
}
